<template>
  <button v-if="isUserLoggedIn" @click="ShowDrop" class="d-flex align-center justify-end px-2"  ref="profileMenu">
    <img :src="userdata.image" alt="" v-if="userdata.image" class="companyimage">
    <v-icon icon="mdi-account" v-else></v-icon>
    <div style="
    width: 125px;
">
      <p v-if="userdata.name" class="px-1 font-weight-bold text-right">
        {{ userdata.name }}
      </p>
      <p v-else class="px-1 font-weight-bold text-right">
        {{ $t("Profile") }}
      </p>

      <p class="afaz_auth" v-if="userdata.is_nafath_verified"   >
        <svg aria-hidden="true" data-prefix="fas" data-icon="badge-check" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"  width="18" height="18" class="svg-inline--fa fa-badge-check fa-w-16 fa-7x">
          <path fill="#2ea156" d="M512 256c0-37.7-23.7-69.9-57.1-82.4 14.7-32.4 8.8-71.9-17.9-98.6-26.7-26.7-66.2-32.6-98.6-17.9C325.9 23.7 293.7 0 256 0s-69.9 23.7-82.4 57.1c-32.4-14.7-72-8.8-98.6 17.9-26.7 26.7-32.6 66.2-17.9 98.6C23.7 186.1 0 218.3 0 256s23.7 69.9 57.1 82.4c-14.7 32.4-8.8 72 17.9 98.6 26.6 26.6 66.1 32.7 98.6 17.9 12.5 33.3 44.7 57.1 82.4 57.1s69.9-23.7 82.4-57.1c32.6 14.8 72 8.7 98.6-17.9 26.7-26.7 32.6-66.2 17.9-98.6 33.4-12.5 57.1-44.7 57.1-82.4zm-144.8-44.25L236.16 341.74c-4.31 4.28-11.28 4.25-15.55-.06l-75.72-76.33c-4.28-4.31-4.25-11.28.06-15.56l26.03-25.82c4.31-4.28 11.28-4.25 15.56.06l42.15 42.49 97.2-96.42c4.31-4.28 11.28-4.25 15.55.06l25.82 26.03c4.28 4.32 4.26 11.29-.06 15.56z"></path>
        </svg>
        {{ $t("afaz_auth") }}
      </p>
    </div>

  </button>

  <div class="menu_acount"  v-if="isUserLoggedIn" :class="{ active: isMenuOpen }">
    <ul>
      <li><a  @click="profile" ><i class="ph-bold ph-user"></i> {{ $t("Profile") }}</a></li>
      <li class="log-out"><a @click="logout" ><i class="ph-bold ph-sign-out"></i> {{ $t('logout') }}</a></li>
    </ul>
  </div>
  <button class="px-2 d-flex align-center justify-end" @click="resigt" v-else>
    <v-icon icon="mdi-account-outline"></v-icon>
    <p style="width: 100px">
    {{ $t("LogIn") }}
    </p>
  </button>
</template>
<script>
import { ref, onMounted, onBeforeUnmount } from "vue";
import { useAuth } from "../../axios";
import crudDataService from "@/Services/crudDataService";
export default {
  data(){
    return{
      isMenuOpen: false,
      logined:"",
      userdata:''
    }
  },
  setup() {
    const { isLoggedIn } = useAuth();
    const isUserLoggedIn = ref(isLoggedIn());
    return {
      isUserLoggedIn,
    };
  },
  components: {},
  methods: {
    async userprofile() {
      const id = localStorage.getItem("userId");
      if (id) {
      let response = await crudDataService.get(`user-profile`, id);
      this.userdata=response.data.data
      // console.log(this.userdata);
      }
    },
    resigt() {
      this.$router.push({ name: "LogIn" });
    },ShowDrop() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    profile() {
      this.isMenuOpen = false;
      this.$router.push({ name: "Account_settings" });

    },closeMenuOnClickOutside(event) {
      const profileMenu = this.$refs.profileMenu;
      if (profileMenu && !profileMenu.contains(event.target)) {
        this.isMenuOpen = false;
      }
    },
    async logout(){
      try {
        let response=  await crudDataService.getAll("logout")
        this.$router.push({ name: 'home' })
            .then(() => {
              const {clearToken} = useAuth();
              clearToken()
              window.location.reload();
            });
      }catch(error)  {
        // console.log(error.request);
      }



    }
  },
  mounted() {
    this.userprofile()
    // this.logined = localStorage.getItem("authToken")?true:false
    // // console.log(this.logined);
    document.addEventListener("click", this.closeMenuOnClickOutside);
  },beforeUnmount() {
    document.removeEventListener("click", this.closeMenuOnClickOutside);
  },
};

</script>
<style lang="scss" scoped>


.profile h3 {
  text-align: end;
  line-height: 1;
  margin-bottom: 4px;
  font-weight: 600;
}

.profile p {
  line-height: 1;
  font-size: 14px;
  opacity: .6;
}

.profile .img-box {
  position: relative;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  overflow: hidden;
}

.profile .img-box img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* menu (the right one) */

.menu_acount {
  display: none;
  position: absolute;
  top: 180px;
  left: 35px;
  width: 200px;
  min-height: 95px;
  background: #fff;
  box-shadow: 0 10px 20px rgba(0, 0, 0, .2);
  opacity: 0;
  z-index: 9;
}

.menu_acount::before {
  content: "";
  position: absolute;
  top: -5px;
  left: 88%;
  width: 20px;
  height: 20px;
  background: #ffffff;
  transform: rotate(45deg);
  z-index: 10;
}

.menu_acount.active {
  display: block;
  opacity: 1;
  transform: translateY(0);
  visibility: visible;
}


.menu_acount ul li {
  list-style: none;
  cursor: pointer;
  width: 100%;
  text-align: center;

  margin: 5px auto 0;

}

.menu_acount ul li:hover {
  background: #eee;
}
.menu_acount ul li.log-out {
  background-color: #ff00002e;
  color: #590606;
}
.menu_acount ul li.log-out:hover {
  background-color: #590606;
  color: #eee;
}

.menu_acount ul li a {
  text-decoration: none;
  color: #000;
  display: grid;
  align-items: center;
  text-align: center;
  margin: auto;
  padding: 10px;
  font-size: 18px;
  font-weight: 500;

}
.menu_acount ul li.log-out a {
  color: #590606;
}
.menu_acount ul li.log-out:hover a {
  color: #eee;
}
.menu_acount ul li a i {
  font-size: 1.2em;
}
.companyimage{
  width: 50px;
    height: 50px;
    border-radius: 50%;
    box-shadow: 0px 1px 5px 1px #00000054;
}
.afaz_auth{
  color: #2ea156;
  display: flex;
  align-items: center; /* يجعل المحتوى في المنتصف عموديًا */
  gap: 8px; /* مسافة بين الأيقونة والنص */
}

.name_user{
  font-size: 10px;
}
.afaz_auth svg {
  flex-shrink: 0; /* يمنع تصغير الأيقونة عند ضغط المساحة */
}
</style>
